<template>
    <form-row title="Who Pays for the Site Development?" :no_border="true" class="mt-8">
        <buyer-seller-split
            field="site_development_who_pays"
            :value="commercial.site_development_who_pays"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
import BuyerSellerSplit from '../../buyer-seller-split.vue';

export default {
    components: {
        BuyerSellerSplit,
    },

    props: {
        commercial: { default: () => ({}) },
        read_only: { default: false },
    },
}
</script>
